export default "__VITE_ASSET__BOkNiUvn__"